import { AsyncSubject, Observable } from 'rxjs'

import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core'
import { MatSnackBar } from '@angular/material'
import { FormControl } from '@angular/forms'

import { AuthService } from '../auth.service'
import { Secure } from '../../data/secure'
import { User } from '../interfaces'

import { LoginInterruptedByUserError } from '../errors'
import { WallComponent } from '../../components/wall/wall.component';
import {ActivatedRoute, Router} from '@angular/router';
import { FirestoreService } from '../../data/firestore.service';


export interface StrategyType {
  name: string
  expression: RegExp
  screen: ElementRef<HTMLFormElement>
  userField: FormControl
  codeField?: FormControl
  fieldLabel?: string
  codeLabel?: string
  additionalInfo?: string
  activate: (username: string) => Promise<any>
  verify: (username: string, code: string) => Promise<User>
}

export interface StrategyGroup {
  icon?: string
  type?: string
  title?: string
  color?: 'primary' | 'warn' | 'accent' | ''
  userLabel: string
  strategies?: StrategyType[]
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    '../styles/dialog.scss',
    './login.component.scss'
  ]
})
export class LoginComponent implements OnInit {
  @ViewChild(WallComponent) wall: WallComponent

  @ViewChild('userForm') userForm: ElementRef<HTMLFormElement>
  @ViewChild('codeForm') codeForm: ElementRef<HTMLFormElement>

  username: FormControl = new FormControl('')
  code: FormControl = new FormControl('')

  auth: AuthService

  loading = {
    username: false, code: false, password: false
  }

  phase = 'strategy'
  groups: StrategyGroup[]
  group: StrategyGroup
  strategy: StrategyType
  secure: any

  minwidth: number = 800;
  minScreen: boolean;
  showWall: boolean = true;
  userEmail;
  public flagQR: boolean ;
  private authenticated: AsyncSubject<User | Error> = new AsyncSubject<User | Error>()
  errorMessage: any

  constructor (
    private snack: MatSnackBar,
    private router: Router,
    private firestore: FirestoreService
  ) { }

  ngOnInit() {
    this.firestore.doc('/domain/switches').subscribe(result => {
      this.flagQR = result['QR']?true:false;
      console.log("FLAGQR",result['QR']);
    });
    this.secure = new Secure('SSI_DEFAULT_INNER KEY', '1234123412341234')
    this.setPublic()
    if(window.innerWidth<this.minwidth)
    {
      this.minScreen = true;
    }
    else{
      this.minScreen = false;
    }
  }

  ngAfterViewInit() {
    if((window.location.href).substr((window.location.href).length-5,(window.location.href).length) === 'admin'){
      setTimeout(() => {this.setSecret()}, 500);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if(window.innerWidth<this.minwidth){
      this.minScreen = true;
      this.hide()
    }
    else{
      this.minScreen = false;
      this.show()
    }
  }

  setPublic () {
    this.userEmail = '';
    this.groups = [
      {
        icon: 'assets/newIcons/ClickPay-White-Vertical2.svg',
        type: 'castomer',
        userLabel: 'Número de teléfono o correo electrónico',
        strategies: [
          {
            name: 'email',
            expression: /^[\u0020-\uffff]+@(?:[\u0020-\uffff]+\.)+?[\u0020-\uffff]{2,}$/,
            screen: this.codeForm,
            userField: this.username,
            fieldLabel: 'Se envió un mensaje con un código al correo electrónico ',
            codeField: this.code,
            codeLabel: 'Código de confirmación',
            activate: (email: string) => this.auth.verifyUserVerificationEmail(email, 'CUSTOMER').then( data => {
              this.userEmail = this.secure.decrypt(data.data);
              console.log(this.userEmail);
            }),
            verify: (username: string, password: string) =>
              this.auth.verifyUserAuth(this.userEmail, this.secure.encrypt(password))
                .then(credential => credential.user as User)
          },
          {
            name: 'phoneNumber',
            expression: /^[-+ ()\d]{7,}$/,
            screen: this.codeForm,
            userField: this.username,
            codeField: this.code,
            codeLabel: 'Código de confirmación',
            fieldLabel: 'Se envió un código de confirmación al número ',
            activate: (phoneNumber: string) => this.auth.verifyUserVerificationSMS('+591' + phoneNumber, 'CUSTOMER'),
            verify: (phoneNumber: string, code: string) =>
              this.auth.verifyConfirmationCode(code)
              .then(credential => credential.user as User)
          },
        ]
      },
      {
        icon: 'assets/newIcons/ClickBusiness_Vertical_white_All3.svg',
        type: 'business',
        title: 'Business',
        color: 'warn',
        userLabel: 'Usuario o código de empresa',
        strategies: [
          {
            name: 'pin4',
            expression: /^\d{4}$/ ,
            screen: this.codeForm,
            userField: this.username,
            codeField: this.code,
            codeLabel: 'PIN',
            fieldLabel: 'Usuario: ',
            activate: (code: string) => Promise.resolve(),
            verify: (code: string, pin: string) =>
              this.auth.verifyUserAuthValid(`${code}${pin}`, pin.length > 4 ? pin : this.secure.encrypt(code + pin), 'BUSINESS')
              .then(credential => credential.user as User)
          },
          {
            name: 'pin6',
            expression: /^\w+\d{4}$/ ,
            screen: this.codeForm,
            userField: this.username,
            codeField: this.code,
            codeLabel: 'Contraseña',
            fieldLabel: 'Código de empresa: ',
            activate: (code: string) => Promise.resolve(),
            verify: (code: string, pin: string) =>
              this.auth.verifyUserAuth(code, this.secure.encrypt(pin))
              .then(credential => credential.user as User)
          }
        ]
      },
    ]
  }

  setSecret () {
    this.groups = [
      {
        icon: 'assets/newIcons/clickAdmin-White-Vertical2.svg',
        type: 'admin',
        title: 'Administrador',
        color: '',
        userLabel: 'Correo electrónico o número de teléfono',
        strategies: [
          {
            name: 'phoneNumber',
            expression: /^[-+ ()\d]{7,}$/,
            screen: this.codeForm,
            userField: this.username,
            codeField: this.code,
            codeLabel: 'Código de confirmación',
            fieldLabel: 'Se envió un código de confirmación al número ',
            activate: (phoneNumber: string) => this.auth.verifyUserVerificationSMS('+591' + phoneNumber, 'OPERATOR'),
            verify: (phoneNumber: string, code: string) =>
              this.auth.verifyConfirmationCode(code)
              .then(credential => credential.user as User)
          },
          {
            name: 'email',
            expression: /^[\u0020-\uffff]+@(?:[\u0020-\uffff]+\.)+?[\u0020-\uffff]{2,}$/,
            screen: this.codeForm,
            userField: this.username,
            fieldLabel: 'Se envió un mensaje con un código al correo electrónico ',
            codeField: this.code,
            codeLabel: 'Código de confirmación',
            activate: (email: string) => this.auth.verifyUserVerificationEmail(email, 'OPERATOR').then( data => {
              this.userEmail = this.secure.decrypt(data.data);
              console.log(this.userEmail);
            }),
            verify: (username: string, password: string) =>
              this.auth.verifyUserAuth(this.userEmail, this.secure.encrypt(password))
                .then(credential => credential.user as User)
          },
          {
            name: 'username',
            expression: /^\S{4,}$/,
            screen: this.codeForm,
            userField: this.username,
            codeField: this.code,
            codeLabel: 'Contraseña',
            fieldLabel: 'Usuario ',
            activate: (username: string) => Promise.resolve(),
            verify: (username: string, password: string) =>
              this.auth.verifyUserAuth(username, this.secure.encrypt(password))
              .then(credential => credential.user as User)
          },
        ]
      },
    ]
  }
  veremos(value){
    console.log(value);
  }
  setGroup (group) {
    this.phase = 'username'
    this.group = group
  }

  unsetGroup () {
    this.retry()
    this.username.setValue('')
    this.phase = 'strategy'
    this.group = null
    this.strategy = null
  }

  back () {
    if (this.strategy) {
      this.retry()
    } else {
      this.unsetGroup()
    }
    this.setPublic();
      if((window.location.href).substr((window.location.href).length-5,(window.location.href).length) === 'admin'){
          this.setSecret()
      }
  }

  show () {
    if(this.showWall && !this.minScreen){
    this.wall.show()
    this.retry()
    }
  }

  hide () {
    this.wall.hide()
  }

  cancel () {
    this.hide()
    this.authenticated.error(new LoginInterruptedByUserError())
    this.authenticated.complete()
  }

  retry () {
    if (this.strategy) {
      this.strategy.screen.nativeElement.removeAttribute('current')
      this.strategy = null
    }
    this.userForm.nativeElement.setAttribute('current', '')
  }

  authenticate (): Observable<User | Error> {
    setTimeout(() => this.show(), 200)
    return this.authenticated
      .finally(() => this.hide())
  }

  validStrategy (username: string) {
    return !!this.group.strategies.find(strategy => strategy.expression.test(username))
  }

  pickStrategy (username: string) {
    this.strategy = this.group.strategies.find(strategy => strategy.expression.test(username))
    if (this.strategy) {
      this.strategy.userField.disable()
      this.loading.username = true
      this.strategy.activate(username).then(() => {
        this.userForm.nativeElement.removeAttribute('current')
        this.strategy.screen.nativeElement.setAttribute('current', '')
      })
      .catch(reason => {
        this.snack.open(reason.message, 'Aceptar', { duration: 3000 })
        setTimeout(() => this.strategy.userField.setErrors({ api: reason.message }), 0)
      })
      .then(() => {
        delete this.loading.username
        this.strategy.userField.enable()
      })
    }
  }

  verifyStrategy () {
    if (this.strategy) {
      this.strategy.codeField.disable()
      this.loading.code = true
      this.strategy.verify(this.strategy.userField.value, this.strategy.codeField.value)
      .then(user => {
        this.showWall = false
        this.authenticated.next(user)
        this.authenticated.complete()
      })
      .catch(reason => {
        // TODO Prevent too many attempts:
        // - Keep count
        // - Throw error:
        //  this.authenticated.error(new TooManyAttemptsError)
        this.snack.open(reason.message, 'Aceptar', { duration: 3000 })
        setTimeout(() => this.strategy.codeField.setErrors({ api: reason.message }), 0)
      })
      .then(() => {
        delete this.loading.code
        this.strategy.codeField.enable()
      })
    }
  }

}
